import { createContext, useContext } from 'react'

/** @typedef {import('@/theme/appearanceTheme').AppearanceMode} AppearanceMode */

/** @type {import('react').Context<{ mode: AppearanceMode, setMode: (mode: AppearanceMode) => void, resolvedMode: 'light' | 'dark' } | null>} */
export const AppearanceThemeContext = createContext(null)

/** @returns {{ mode: AppearanceMode, setMode: (mode: AppearanceMode) => void, resolvedMode: 'light' | 'dark' }} */
export function useAppearanceTheme() {
  const ctx = useContext(AppearanceThemeContext)
  if (!ctx) {
    throw new Error('useAppearanceTheme must be used within AppThemeProvider')
  }
  return ctx
}
